import { LottieAnimations } from 'src/assets'

const { mobile, web, uiux, project } = LottieAnimations.Capabilities

const Capabilities = {
  mobile: {
    title: 'Frontend Architecture',
    description:
      'Scalable component systems, state management, performance-critical UIs, and design system development',
    media: mobile,
  },
  web: {
    title: 'Complex State & Data Flows',
    description: 'Handling async, performance, and consistency at scale',
    media: web,
  },
  design: {
    title: 'Team Enablement',
    description: 'Reusable patterns, developer experience, mentorship, system documentation',
    media: uiux,
  },
  project: {
    title: 'End-to-End Ownership',
    description: 'Design collaboration → Technical design → Production deployment → Monitoring',
    media: project,
  },
}

export { Capabilities }
